(function () {
  function pad(n) {
    return String(Math.max(0, n)).padStart(2, "0");
  }

  function parseTarget(str) {
    // Convert +0000 to +00:00 if needed for Date parsing
    var s = str;
    if (s && /[+-]\d{4}$/.test(s)) {
      s = s.replace(/([+-]\d{2})(\d{2})$/, "$1:$2");
    }
    var d = new Date(s);
    return isNaN(d.getTime()) ? null : d;
  }

  function tick(el) {
    var targetStr = el.getAttribute("data-countdown-to");
    var target = parseTarget(targetStr);
    if (!target) return;

    var now = new Date();
    var diff = target.getTime() - now.getTime();

    if (diff <= 0) {
      el.style.display = "none"; // hide when ended
      return;
    }

    var totalSeconds = Math.floor(diff / 1000);
    var days = Math.floor(totalSeconds / 86400);
    var hours = Math.floor((totalSeconds % 86400) / 3600);
    var mins = Math.floor((totalSeconds % 3600) / 60);
    var secs = totalSeconds % 60;

    var dEl = el.querySelector("[data-days]");
    var hEl = el.querySelector("[data-hours]");
    var mEl = el.querySelector("[data-mins]");
    var sEl = el.querySelector("[data-secs]");

    if (dEl) dEl.textContent = pad(days);
    if (hEl) hEl.textContent = pad(hours);
    if (mEl) mEl.textContent = pad(mins);
    if (sEl) sEl.textContent = pad(secs);
  }

  function init() {
    var timers = document.querySelectorAll("[data-countdown][data-countdown-to]");
    if (!timers.length) return;

    timers.forEach(tick);
    setInterval(function () {
      timers.forEach(tick);
    }, 1000);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();